React = require 'react'
_ = require 'underscore'
t = require('views/internal/recup-with-helpers')('home')

module.exports = class extends React.Component
  displayName: 'BoardlistSectionHeaderLinkComponent'

  render: t.renderable ->
    { url, iconClass, titleKey, titleText, onClick, linkClasses } = @props

    defaultClasses =
      'home-section-header-link-item': true
      'dark-hover': true

    classes = _.extend(defaultClasses, linkClasses)

    # We deliberately don't use the icon/locale-key overload of t.icon
    # because it inserts a space between the icon and its text, which
    # looks weird since the text will be underlined.

    t.a {
      href: url
      class: t.classify(classes)
      onClick: onClick
    }, =>
      t.icon iconClass, { class: 'home-section-header-link-item-icon' }
      t.span '.home-section-header-link-item-name', =>
        t.format titleKey
        if titleText
          t.text ": #{titleText}"



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-section-header-link-component.coffee